module.exports = __webpack_public_path__ + "static/media/ph_clipboard_data_2.e8d8cf51.svg";